var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSubtitlesActive)?_c('div',{staticClass:"block-overlay-canvas",style:(_vm.subtitleStyle)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subtitlesText)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }